<!--
 * @Author:
 * @LastEditTime: 2026-01-15 11:19:08
 * @Description:
-->
<!--  -->
<template>
  <div class="h-full w-full">
    <!-- 顶部 -->
    <div class="absolute z-9 w-full flex justify-between items-center training-header ">
      <div class="h-full flex-1 relative" v-for="item in headerImgs" :key="item.key">
        <span
          v-if="item.text"
          class="text-white text-2xl font-bold absolute top-2/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2 header-text"
          >{{ item.text }}</span
        >
        <img :src="item.src" alt="" class="h-full w-full" />
      </div>
    </div>
    <div
      class="z-998 btn cursor-pointer w-100px h-35px absolute right-1/50 top-1/20"
      @click="goBack"
    >
      返回
    </div>
    <el-tooltip effect="dark" content="模型树" placement="bottom">
      <div
        class="absolute z-99 top-85px w-32px h-36px bg-[#0074c9cc] rounded-r-4px cursor-pointer p-7px pt-10px"
        :style="{ left: showModelTree ? '410px' : '0px' }"
        @click="openComponents('ModelTree')"
      >
        <img
          :src="showModelTree ? require('../images/Vector.png') : require('../images/Vector-1.png')"
          alt=""
          srcset=""
          class="w-17px h-17px"
        />
      </div>
    </el-tooltip>
    <el-tooltip effect="dark" content="步骤列表" placement="bottom">
      <div
        class="absolute z-99 top-90px  w-32px h-36px bg-[#0074c9cc] rounded-l-4px p-7px pt-10px"
        :style="{ right: showStepList ? '410px' : '0px' }"
        @click="openComponents('StepList')"
      >
        <img
          :src="showStepList ? require('../images/Vector-1.png') : require('../images/Vector.png')"
          alt=""
          srcset=""
          class="w-17px h-17px"
        />
      </div>
    </el-tooltip>
    <ModelViewVulkan
      :sceneOptions="sceneOptions"
      @sendPlayer="sendPlayer"
      :cloudRender="cloudRender"
      @loadSceneEnd="loadSceneEnd"
      @modelClick="modelClick"
    ></ModelViewVulkan>
    <!-- 模型树 -->
    <ModelTree
      :player="player"
      :cloudRender="cloudRender"
      v-if="showModelTree"
      class="model-tree"
    ></ModelTree>
    <StepList
      :player="player"
      v-show="loadModelStatus && showStepList"
      ref="stepList"
      :steps="steps"
      :cloudRender="cloudRender"
      :schemeId="schemeId"
      :loadSceneEnd="loadModelStatus"
      :currentSelectModel="currentNode"
    ></StepList>
  </div>
</template>

<script>
import _ from 'lodash'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import { ModelSceneApi } from '@wiz-api/scene-management'
import { EquipDisAssembleySolutionApi } from '@wiz-api/equipment-assembly-trainning'

const equipDisAssembleySolution = new EquipDisAssembleySolutionApi()
const modelSceneApi = new ModelSceneApi()

const ModelViewVulkan = () => {
  return import('@/components/model-vulkan/ModelViewVulkan')
}
const ModelTree = () => {
  return import('@/components/model-vulkan/ModelTreeVulkan')
}
const StepList = () => {
  return import('../components/StepList')
}
export default {
  name: '',
  components: {
    ModelViewVulkan,
    ModelTree,
    StepList,
  },
  data() {
    return {
      headerImgs: [
        {
          key: 'left',
          src: require('../images/training_left.png'),
        },
        {
          key: 'center',
          src: require('../images/training_center.png'),
          text: '设备拆解培训',
        },
        {
          key: 'right',
          src: require('../images/training_right.png'),
        },
      ],
      loading: false,
      sceneOptions: {
        isEnableGis: '',
        longitude: '',
        latitude: '',
        name: '',
        id: '',
        jsonData: '',
      },
      player: {},
      loadModelStatus: false,
      currentNode: null, // 当前激活的节点
      showModelTree: false,
      showStepList: false,
      // 步骤
      schemeId: '', // 方案id
      schemeDetail: {},
      steps: [], // 方案列表
    }
  },
  computed: {
    cloudRender() {
      window.cloudRender = cloudRender
      return cloudRender
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (Array.isArray(routerBase)) {
        // 多个微服务场景取第一个基础微服务
        return `/${routerBase[0]}`
      }
      return routerBase ? `/${routerBase}` : ''
    },
  },
  methods: {
    goBack() {
      this.$router.push(`${this.basePath}/equipment-disassemble-training/list`)
    },
    sendPlayer(player) {
      this.player = player
    },
    // 场景加载完成
    loadSceneEnd(node = null) {
      this.loadModelStatus = true
      this.showModelTree = true
      this.showStepList = true
    },
    modelClick(e) {
      console.log(e)
      this.currentNode = e.node
      this.player.Native.Node.selectNodes([e.node])
    },
    openComponents(type) {
      console.log(type)
      if (!this.player) {
        this.$message.warning('模型加载完成后，再开启！')
        return
      }
      this.showModelTree = type === 'ModelTree' ? !this.showModelTree : this.showModelTree
      this.showStepList = type === 'StepList' ? !this.showStepList : this.showStepList
      console.log(this.loadModelStatus, this.showStepList)
      // this.showTagBasicInfo =
      //   type === 'TagBasicInfo' ? !this.showTagBasicInfo : (this.showTagBasicInfo = false)
    },
    // 方案详情
    async getSchemeDetail() {
      console.log(this.schemeId)
      const [err, res] = await equipDisAssembleySolution.get(this.schemeId)
      if (!err && !_.isNil(res)) {
        this.steps = _.map(res.steps, (el) => {
          return {
            ...el,
            targetLocation: el.targetLocation.split(','),
            srcLocation: el.srcLocation.split(','),
          }
        })
        this.getSceneDetail(res.modelId)
        return res
      }
      return {}
    },
    // 获取场景详情
    async getSceneDetail(id) {
      const [err, res] = await modelSceneApi.get(id)
      let options = null
      if (!err && !_.isNil(res)) {
        options = _.pick(res, ['isEnableGis', 'latitude', 'longitude', 'name', 'id', 'folderId'])
      }
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id })
      if (!jsonErr) {
        options.jsonData = jsonRes
        this.sceneOptions = _.cloneDeep(options)
      }
    },
  },
  async created() {
    this.schemeId = this.$route.query.id
    this.schemeDetail = await this.getSchemeDetail()
  },
  beforeDestroy() {
    if (this.cloudRender && this.player) {
      this.cloudRender.Engine.destroyEngine()
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../css/index.scss';

.h-35px {
  height: 35px !important;
}
.h-36px {
  height: 36px !important;
}
.training-header {
  height: 80px !important;
  .header-text {
    transform: translate(-50%, -50%) !important;
  }
}
.btn {
  text-align: center;
  color: #fff !important;
  background: url('../images/button.png') no-repeat !important;
  padding: 0px !important;
  line-height: 30px !important;
  background-size: 100% 100% !important;
}
.model-tree {
  left: 10px;
  top: 40px;
  height: calc(100% - 60px) !important;
  width: 400px;
  z-index: 99;
  padding: 10px;
  color: #fff !important;
  background-color: #2e6bb07f !important;
  border: none !important;
}
</style>
